export enum Permissions {
    MOVE_TEMPLATES = 'MOVE_TEMPLATES',
    CREATE_REPORTS = 'CREATE_REPORTS',
    SYSTEMADMINISTRATION = 'SYSTEMADMINISTRATION',
    DELETE_FOLDER_TEMPLATES = 'DELETE_FOLDER_TEMPLATES',
    ROLE_ADMINISTRATION = 'ROLE_ADMINISTRATION',
    MASTER_DATA_ADMINISTRATION = 'MASTER_DATA_ADMINISTRATION',
    ITO_SHORT_FORM_TO_ANALYSIS = 'ITO_SHORT_FORM_TO_ANALYSIS',
    RECALCULATE_RISK_INDICES = 'RECALCULATE_RISK_INDICES',
    READ_ANALYSIS = 'READ_ANALYSIS',
    WRITE_ANALYSIS = 'WRITE_ANALYSIS',
    RESTORE_ANALYSIS = 'RESTORE_ANALYSIS',
    CREATE_TEMPLATES = 'CREATE_TEMPLATES',
    DELETE_TEMPLATES = 'DELETE_TEMPLATES',
    CANCEL_ANALYSIS = 'CANCEL_ANALYSIS',
    MOVE_FOLDER_TEMPLATES = 'MOVE_FOLDER_TEMPLATES',
    IMPORT_ANALYSIS = 'IMPORT_ANALYSIS',
    USER_ADMINISTRATION = 'USER_ADMINISTRATION',
    RELEASE_ANALYSIS = 'RELEASE_ANALYSIS',
    EDIT_TEMPLATES = 'EDIT_TEMPLATES',
    EXPORT_ANALYSIS = 'EXPORT_ANALYSIS',
    USER_ADMINISTRATION_READ_ONLY = 'USER_ADMINISTRATION_READ_ONLY',
    DWSM_EXPERT_FEATURES = 'DWSM_EXPERT_FEATURES'
}

export enum UserTypePermission {
    SUPER_USER = 'SUPER_USER',
    IS_SUPPLIER = 'IS_SUPPLIER',
    IS_BBA = 'IS_BBA'
}
